import { render, staticRenderFns } from "./AssetDetailsView.vue?vue&type=template&id=c8f72f98&"
import script from "./AssetDetailsView.vue?vue&type=script&lang=js&"
export * from "./AssetDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./AssetDetailsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports